(() => {
  const popup = document.querySelector('[data-tt-newsletter]');
  if (!popup) return;

  const dismissedKey = 'techticNewsletterDismissedAt';
  const subscribedKey = 'techticNewsletterSubscribed';
  const preview = popup.dataset.preview === 'true'
    || new URLSearchParams(window.location.search).get('techtic_newsletter_preview') === '1';
  const success = Boolean(popup.querySelector('[data-tt-newsletter-success]'));
  const dismissalWindow = 7 * 24 * 60 * 60 * 1000;
  let opened = false;

  const shouldOpen = () => {
    if (preview || success) return true;
    if (localStorage.getItem(subscribedKey) === 'true') return false;
    const dismissedAt = Number(localStorage.getItem(dismissedKey) || 0);
    return !dismissedAt || Date.now() - dismissedAt > dismissalWindow;
  };

  const open = () => {
    if (opened || !shouldOpen()) return;
    opened = true;
    popup.hidden = false;
    document.body.classList.add('tt-newsletter-open');
    window.setTimeout(() => popup.querySelector('input[type="email"]')?.focus(), 80);
  };

  const close = () => {
    popup.hidden = true;
    document.body.classList.remove('tt-newsletter-open');
    if (!success && !preview) localStorage.setItem(dismissedKey, String(Date.now()));
  };

  popup.querySelectorAll('[data-tt-newsletter-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) close();
  });

  if (success) {
    localStorage.setItem(subscribedKey, 'true');
    open();
    return;
  }
  if (!shouldOpen()) return;
  if (preview) {
    open();
    return;
  }

  const timer = window.setTimeout(open, 7000);
  const onScroll = () => {
    const pageHeight = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    if (window.scrollY / pageHeight >= 0.35) {
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      open();
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  if (window.matchMedia('(pointer:fine)').matches) {
    document.addEventListener('mouseout', (event) => {
      if (event.clientY <= 0 && !event.relatedTarget) open();
    }, { once: true });
  }
})();
